export enum AvailableOrderTypes {
  STANDARD = 'standard',
  CATERING = 'catering',
  GROUP = 'group',
}
